<img src="assets/images/logo.svg" alt="MRR Logo" height="46" />
